module.exports = __webpack_public_path__ + "static/media/glyphicons-basic-picture.7ebd0560.svg";